const ALLOCATIONS_DISABLED =
  'Allocations are disabled for your account. Please contact support@nimble-energy.com to enable this feature.';

export default function generateAllocationInfoTooltip(
  allocationsEnabled: boolean,
  hasActiveAllocation: boolean,
  hasActiveAllocationTooltip: string,
  allocationInfoTooltip: string,
): React.ReactNode {
  if (!allocationsEnabled) {
    return ALLOCATIONS_DISABLED;
  }

  if (hasActiveAllocation) {
    return (
      <>
        {hasActiveAllocationTooltip}
        <br />
        <br />
        {allocationInfoTooltip}
      </>
    );
  }

  return allocationInfoTooltip;
}
